import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import type { Action } from 'state/actions';
import { workspaceTabsFetchRequested } from 'state/workspaces/workspace.actions';

export function initializePostTradeWorkspaceEpic(): SpEpic {
  return action$ => {
    const currentUser$: Observable<Action> = action$.pipe(ofType('USER_CURRENT_RECEIVED'), take(1));

    const onRouteChanged$: Observable<Action> = action$.pipe(
      ofType('ROUTE_CHANGED'),
      filter(({ path }) => path === '/post-trade' || path === '/trade-blotter'),
      take(1),
    );

    return combineLatest([currentUser$, onRouteChanged$]).pipe(map(_ => workspaceTabsFetchRequested('postTrade')));
  };
}
